import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useMemo } from 'react';
import { noop } from "../../utils/noop";
import { MenuGroup } from "./MenuGroup";
var defaultCheckboxGroupContext = {
  checked: new Set(),
  onChange: noop
};
export var MenuCheckboxGroupContext = React.createContext(defaultCheckboxGroupContext);
/**
 * MenuCheckboxGroup
 *
 * A smaller helper for managed groups of Checkbox
 * menu items.
 */

export function MenuCheckboxGroup(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["checked", "onChange", "children"]);

  var checkboxGroupContext = useMemo(function () {
    /**
     * Update our Set depending upon if an entry
     * is checked or not.
     */
    var handleChange = function handleChange(name) {
      var isChecked = checked.has(name);
      var nextSet = new Set(checked);

      if (isChecked) {
        nextSet.delete(name);
      } else {
        nextSet.add(name);
      }

      onChange(nextSet);
    };

    return {
      onChange: handleChange,
      checked: checked
    };
  }, [checked, onChange]);
  return /*#__PURE__*/React.createElement(MenuCheckboxGroupContext.Provider, {
    value: checkboxGroupContext
  }, /*#__PURE__*/React.createElement(MenuGroup, other, children));
}